import { Pipe, PipeTransform } from '@angular/core';

const MESES_EXTENSO = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

/**
 * Formata uma data por extenso em português — ex.: "08 de Julho de 2026".
 *
 * Aceita um `Date` ou uma string ISO ("YYYY-MM-DD"). A string é lida por partes
 * (não via `new Date('YYYY-MM-DD')`) para evitar o deslocamento de um dia por fuso horário.
 * Entrada vazia retorna string vazia; entrada inválida retorna o valor original.
 */
@Pipe({
    name: 'dataExtenso',
    standalone: true,
    pure: true
})
export class DataExtensoPipe implements PipeTransform {
    transform(valor: Date | string | null | undefined): string {
        if (valor === null || valor === undefined || valor === '') {
            return '';
        }

        let ano: number;
        let mes: number;
        let dia: number;

        if (valor instanceof Date) {
            if (Number.isNaN(valor.getTime())) {
                return '';
            }
            ano = valor.getFullYear();
            mes = valor.getMonth() + 1;
            dia = valor.getDate();
        } else {
            [ano, mes, dia] = valor.split('-').map(Number);
        }

        const nomeMes = MESES_EXTENSO[mes - 1];
        if (!ano || !mes || !dia || !nomeMes) {
            return String(valor);
        }

        return `${String(dia).padStart(2, '0')} de ${nomeMes} de ${ano}`;
    }
}
